var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconHand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 25 31",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 13.962V7.637c0-.948-.615-1.726-1.57-1.726-.068 0-.215 0-.283.009-.886.102-1.613.884-1.613 1.768v5.476c0 .44-.034 1.05-.477 1.05h-.018c-.477 0-1.238-.64-1.238-1.119V4.267c0-.884-.464-1.666-1.35-1.768-.07-.009-.224-.009-.293-.009-.954 0-1.823.777-1.823 1.726v8.914c0 .457-.4.832-.86.832-.473 0-.873-.38-.873-.845V1.78c0-.884-.447-1.666-1.333-1.768A3.547 3.547 0 0012.968 0c-.955 0-1.836.777-1.836 1.73v11.387c0 .465-.4.845-.869.845-.464 0-.864-.375-.864-.832V4.267c0-.884-.426-1.666-1.312-1.768-.069-.009-.24-.009-.31-.009-.958 0-1.844.777-1.844 1.726v12.86c0 .478-.18.794-.59.794-.189 0-.279-.064-.438-.217l-2.013-1.935a1.66 1.66 0 00-1.19-.5c-.44 0-.87.167-1.205.5a1.713 1.713 0 00.009 2.422l7.336 9.601v.004l.185 2.508c.03.375.348.747.731.747l12.798-.09c.365 0 .675-.307.722-.67l.335-2.546c.013-.107-.116-.222-.056-.312C24.51 24.362 25 19.362 25 13.962z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHand);
export default __webpack_public_path__ + "static/media/icon_hand.f7361a652e4302c6b83de7b77e99c09c.svg";
export { ForwardRef as ReactComponent };